import { ClickAwayListener } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import React, { useState } from 'react'

const filter = createFilterOptions()

const SavedLocationNameCreatable = ({
  defaultValue,
  handleClickAway = Function.prototype,
  renderInput: RenderInput,
  ...rest
}) => {
  const [value, setValue] = useState(defaultValue)

  return (
    <ClickAwayListener onClickAway={e => handleClickAway(e, value)}>
      <Autocomplete
        clearOnEscape={true}
        filterOptions={(options, params) => {
          return filter(options, params)
        }}
        freeSolo
        getOptionLabel={option => option}
        noOptionsText="test"
        onChange={(event, newValue) => {
          setValue(newValue)
        }}
        options={defaultOptions}
        renderInput={RenderInput}
        renderOption={option => option}
        selectOnFocus
        value={value}
        {...rest}
      />
    </ClickAwayListener>
  )
}

const defaultOptions = ['Home', 'Work']

export default SavedLocationNameCreatable
